export default "__VITE_ASSET__BxnrhRJs__"